import React from 'react';
import styles from './Index.module.css';

function Loading({ message, className }) {
    return (
        <div className={`${styles.loadingContainer} ${className || ''}`}>
            <div className={styles.spinner}></div>
            {message && <p className={styles.loadingText}>{message}</p>}
        </div>
    );
};

export default Loading;